<template>
  <van-popup
    v-model="show"
    position="bottom"
    round
    class="upgrade-pkg-detail-popup"
    :style="{
      width: '10rem',
      'max-height': 'calc(100vh -  7rem)',
      left: '50%',
      'margin-left': '-5rem'
    }"
    safe-area-inset-bottom
    @open="open"
  >
    <div v-if="item.basic" class="upgrade-pkg-detail">
      <div class="header-mask" />
      <div class="header">{{ item.basic.title }}</div>
      <img
        class="ensure"
        src="~images/platform/homepage/yxl-ensure.png"
        alt=""
        @click="isShowEnsure = true"
      />
      <div class="tips">
        单次时长：<span>{{ tips.duration }}min</span>
        <div class="line" />
        套餐次数：<span>{{ tips.num }}</span>
      </div>
      <div v-if="item.basic.package_details" class="detail">
        <p class="title">套餐详情</p>
        <div v-html="item.basic.package_details"></div>
      </div>
      <div class="bottom">
        <div
          v-if="discount"
          class="price-wrap"
          :class="{
            center: discount.dontShowDiscount || !item.basic.total_sale
          }"
        >
          <p class="top">
            <span class="sign">¥</span>
            <span class="price DharmaTypeBebasKai">{{
              discount.totalPrice
            }}</span>
            <span
              v-if="!discount.dontShowDiscount"
              class="origin-price DharmaTypeBebasKai"
              >¥{{ discount.originPrice }}</span
            >
          </p>
          <p v-if="!discount.dontShowDiscount" class="discount">
            <img src="~images/platform/homepage/icon-success.png" alt="" />
            <span>已优惠 ¥{{ discount.discountPrice }}，</span>
            <span>单次{{ discount.singlePrice }}元</span>
          </p>
        </div>
        <div class="btn-wrap">
          <div class="btn" @click="toOrder">预约当前套餐</div>
          <p v-if="item.basic.total_sale" class="num">
            已有{{ item.basic.total_sale }}人购买
          </p>
        </div>
      </div>
    </div>
    <ensureRuleModel :show.sync="isShowEnsure" :zIndex="3000" />
  </van-popup>
</template>

<script>
import { Popup as VanPopup } from 'vant'
import ensureRuleModel from 'lib/component/vue/consult/ensureRuleModel.vue'
import { activityInfo, activityJoinCheck } from 'api/platform/homepage.js'
import { EventBus } from 'component/platform/homepage/eventBus.js'
export default {
  components: {
    VanPopup,
    ensureRuleModel
  },
  props: {
    visible: Boolean,
    item: {
      type: Object,
      default: () => {}
    },
    tips: {
      type: Object,
      default: () => {}
    },
    payParam: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isShowEnsure: false
    }
  },
  computed: {
    show: {
      get: v => v.visible,
      set(v) {
        this.$emit('update:visible', v)
      }
    },
    discount() {
      const { totalPrice, discountPrice } = this.payParam || {}
      if (!totalPrice) return null
      const dontShowDiscount =
        +discountPrice < 1 ||
        ['theme', 'other'].includes(this.item.basic.activity_type)
      return {
        ...this.payParam,
        originPrice: (+totalPrice + +discountPrice).toFixed(2),
        singlePrice: (+totalPrice / +this.tips.l).toFixed(2),
        dontShowDiscount
      }
    }
  },
  methods: {
    toOrder() {
      const { activity_type, url, id } = this.item.basic
      this.$emit('toOrder', { ...this.item, fromDetail: true })
      this.$trackEvent('newprofilepages_plan_detail_click', { package_id: id })
      if (['theme', 'other'].includes(activity_type) && url) {
        const { cid, channel_flag } = this.$route.query
        activityInfo({
          id: id,
          cid,
          channel_flag
        }).then(res => {
          this.pageData = res.data
          this.joinCheck(id, false)
        })
      } else {
        this.emitEvent({ activity_id: id })
      }
    },
    joinCheck(id, hasTeacher) {
      const activity_id = id
      const { cid, channel_flag } = this.$route.query
      activityJoinCheck({ activity_id }).then(res => {
        const { code, message, data } = res
        const { basic: { teacher_id } = {} } = this.pageData
        const teacherId = hasTeacher ? this.$route.params.userId : ''

        if (code === 0) {
          this.toOrderPage(teacherId, activity_id, cid, channel_flag)
        } else if (code === 40001) {
          const { isYixinliApp, isZiXunApp } = this.$platform
          if (isYixinliApp || isZiXunApp || this.isNativeLoginWebviewMp) {
            window.location.href = 'yixinli://open_user_login'
            this.toLogin(teacher_id, activity_id, cid, channel_flag)
          } else {
            this.toOrderPage(teacherId, activity_id, cid, channel_flag)
          }
        } else if (code === 40003 && data?.order_id) {
          this.$toast({
            text: message,
            time: 1500,
            callback: () => {
              this.routerToStaic({
                path: `/resv-order-detail-user?id=${data.order_id}&hideNavigationBar=1&fromUpPkg=1`
              })
            }
          })
        } else {
          return this.$toast(message)
        }
      })
    },
    toOrderPage(teacher_id, activity_id, cooperation_channel_id, channel_flag) {
      this.routerPushWithoutNav(
        {
          path: '/consult-order-page',
          query: {
            to_user_id: teacher_id || '',
            xlt_studio_id: this.$route.query.xlt_studio_id || '',
            activity_id,
            cooperation_channel_id,
            channel_flag,
            fromUpPkg: 1,
            other_instructions: this.$route.params.userId
          }
        },
        `https://static.xinli001.com/msite/index.html`,
        true,
        'hash'
      )
    },
    emitEvent(params = {}) {
      EventBus.$emit('toZxOrder', params)
    }
  }
}
</script>
<style>
.upgrade-pkg-detail-popup .draw-whale.fixed-center {
  position: absolute;
}
</style>
<style lang="scss" scoped>
.upgrade-pkg-detail {
  padding: 50px 30px 0;
  margin-bottom: 148px;
  .header-mask {
    width: 750px;
    height: 50px;
    background: #fff;
    position: fixed;
    margin-left: -30px;
    border-radius: 30px 30px 0 0;
    margin-top: -50px;
  }
  .header {
    font-size: 38px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 700;
    color: #21252d;
    line-height: 57px;
    margin-bottom: 20px;
  }
  .tips {
    display: flex;
    align-items: center;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #6c798c;
    line-height: 49px;
    margin-top: 20px;
    span {
      font-size: 24px;
      color: rgba(33, 37, 45, 1);
      font-weight: 700;
    }
    .line {
      width: 1px;
      height: 20px;
      background: #bcc2cf;
      margin: 0 20px;
    }
  }
  .detail {
    p.title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 700;
      color: #21252d;
      line-height: 49px;
      margin: 30px 0 16px;
    }
    & > div {
      * {
        max-width: 100% !important;
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    // left: 0;
    margin-left: -30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 750px;
    height: 148px;
    background: #ffffff;
    box-shadow: 0px -8px 20px -10px #ebefff;
    border-radius: 30px 30px 0px 0px;
    padding: 0 32px;
    box-sizing: border-box;
    .price-wrap {
      &.center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .top {
          height: auto !important;
        }
      }
      .top {
        display: flex;
        align-items: flex-end;
        color: #ffa202;
        width: 100%;
        height: 86px;
        .sign {
          font-size: 30px;
        }
        .price {
          font-size: 42px;
          margin-right: 10px;
        }
        .origin-price {
          font-size: 22px;
          color: #bcc2cf;
          text-decoration: line-through;
        }
      }
      .discount {
        display: flex;
        align-items: center;
        margin-top: 4px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #333333;
        line-height: 22px;
      }
    }
    .btn-wrap {
      .btn {
        height: 86px;
        background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
        border-radius: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 700;
        color: #ffffff;
        line-height: 86px;
        text-align: center;
        padding: 0 38px;
      }
      .num {
        text-align: center;
        color: #9da3ac;
        font-size: 22px;
        margin-top: 4px;
      }
    }
  }
}
</style>
